"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var ApplicationDiscussionHeader = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ApplicationDiscussionHeader, _Component);

  function ApplicationDiscussionHeader() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ApplicationDiscussionHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ApplicationDiscussionHeader)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "header", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "selectNotificationById", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "allNotifications", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ApplicationDiscussionHeader, [{
    key: "selectRelated",
    value: function selectRelated() {
      var _this2 = this;

      var app = this.allNotifications.items.filter(function (item) {
        return item.application == _this2.node.application.relatedApplication.id;
      })[0];
      if (app) this.selectNotificationById(app.id); // this.selectNotificationById(`application:${this.node.application.relatedApplication.id}`);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "notification-assignment-header application-header"
      }, _react.default.createElement("h4", null, "Application"), _react.default.createElement("div", {
        className: "activity-info"
      }, _react.default.createElement("h3", null, this.node.catalogItem.typeName), _react.default.createElement("h2", null, this.node.catalogItem.title), this.node.application.isScholarship && _react.default.createElement("div", {
        className: "scholarship-header"
      }, "Scholarship Application"), this.node.application.relatedApplication && _react.default.createElement("div", {
        className: "related-application-header"
      }, this.node.account.name, ' has ', this.node.application.relatedApplication.status == 'approved' ? 'an' : 'a', ' ', _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.selectRelated,
        className: "alert-link"
      }, this.node.application.relatedApplication.status, ' ', this.node.application.relatedApplication.isScholarship && 'scholarship ', 'application'), ' for this item', this.node.application.relatedApplication.status == 'approved' && !!this.node.application.relatedApplication.discount && " that includes a ".concat(this.node.application.relatedApplication.discount, "% discount"), '.'), this.node.itemPrice == 0 ? _react.default.createElement("h5", null, "Free") : _react.default.createElement("h5", null, "Base Price: $", this.node.itemPrice.toFixed(2), this.node.priceSuffix)));
    }
  }]);
  return ApplicationDiscussionHeader;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "header", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "selectNotificationById", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "allNotifications", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "selectRelated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "selectRelated"), _class.prototype)), _class);
exports.default = ApplicationDiscussionHeader;